export const hooks = {
    props: ['hooks'],
    methods: {
        doHook(hookName){
            return function(component){
                if(typeof component !== 'undefined' 
                && typeof component.hooks !=='undefined'
                &&  component.hooks.hasOwnProperty(hookName)){
                    const action = component.hooks[hookName].bind(component);
                    action();
                } else {
                    return false;
                }
            }(this)
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/hooks.js